import { createFileRoute } from "@tanstack/react-router";

import { Publish } from "@/features/marketing/Publish";

export const Route = createFileRoute("/publish")({
  component: Publish,
});
